{{#if title}}
    <strong class="filter-title-text">{{title}}</strong>
{{/if}}

<span class="filter-value-text">{{label}}</span>

<span class="remove-filter">
    {{icon name="circle-close-solid" locale="clearFilter"}}
</span>